import React from "react";
import { TiDeleteOutline } from "react-icons/ti";

const DeleteButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-6 h-6 flex justify-center items-center bg-red-100 text-red-500 rounded-full scale-100 hover:scale-110 duration-300"
    >
      <TiDeleteOutline className="text-lg" />
    </button>
  );
};

export default DeleteButton;
